/**
 * Created by Ella Ma on 7/10/2019.
 * Description:
 *
 * ------ maintenance history ------
 */
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { StoreQuerierService } from '../../services/store-querier.service';

@Injectable({
    providedIn: 'root'
})
export class AuditGuard implements CanActivate {
    constructor(
        private _router: Router,
        private _storeQuerier: StoreQuerierService,
    ) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const currentUser = this._storeQuerier.getCurrentUser();
        if (!currentUser.credential.compliance) {
            this._router.navigate(['/error']);
            return false;
        }
        return true;
    }
}
